import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'http://176.9.114.108:8085'; // Replace with your Supabase URL
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjoiYW5vbiIsImlzcyI6InN1cGFiYXNlIiwiaWF0IjoxNzM2MDI5MjMxLCJleHAiOjE3Njc1NjUyMzF9.ASF36YYVyPwv6klHO7K3nGKv7he89trNI9_BITkVs_U'; // Replace with your Supabase anon key

export const supabase = createClient(supabaseUrl, supabaseAnonKey);